module.exports = "<div *ngIf=\"mostrar\" class=\"mensaje\">\r\n  <div class=\"mensaje-header\">\r\n    <span class=\"titulo\">{{ titulo }}</span>\r\n  </div>\r\n  <div class=\"mensaje-body\">{{ mensaje }}</div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/home/Components/mensaje-dm.component.html
// module id = ../../../../../src/app/home/Components/mensaje-dm.component.html
// module chunks = main